export enum ScalingPolicyPaths {
  VPA_SETTINGS = 'vpa-settings',
  HPA_SETTINGS = 'hpa-settings',
  ASSIGNMENT_RULES = 'assignment-rules',
}
